<template>
  <div
    v-if="!isShowButtonBelow"
    style="height: 56px"
    :class="[
      'tw-flex tw-leading-[100%] !tw-justify-between  tw-gap-[10px] tw-bg-[#ffffff] tw-rounded-md tw-p-[25px] tw-mb-[10px]',
      classesMoreDetail,
    ]"
  >
    <div class="tw-flex tw-flex-col tw-pt-[10px] tw-justify-center">
      <slot>
        <span
          class="tw-text-[14px] tw-font-poppins tw-text-[#231F20] tw-leading-[100%] tw-font-medium tw-mr-[7px] tw-mb-[4px]"
          >{{
            getComponentUiText(
              "app-component-wizards-setup-wizard-more-detail-title-1",
            )
          }}</span
        >
        <span
          class="tw-text-[12px] tw-font-poppins tw-text-[#878787] tw-leading-normal tw-font-normal tw-mr-[7px]"
          >{{
            getComponentUiText(
              "app-component-wizards-setup-wizard-more-detail-sub-title-1",
            )
          }}</span
        >
      </slot>
    </div>
    <div class="tw-flex tw-flex-end tw-items-center tw-bg-[#FFFFFF]">
      <ToggleSwitch
        :is-checked="isMoreDetails"
        color="#2573E9"
        @update:is-checked="changeMoreDetail"
      />
    </div>
  </div>

  <div
    v-if="isShowButtonBelow"
    style="height: 56px"
    :class="[
      'tw-flex tw-leading-[100%] tw-justify-between  tw-gap-[10px] tw-bg-[#ffffff] tw-rounded-md tw-p-[25px] more__detail',
      classesMoreDetail,
    ]"
  >
    <div class="tw-flex tw-flex-col tw-pt-[10px] tw-justify-center">
      <slot>
        <span
          class="tw-text-[14px] tw-font-poppins tw-text-[#231F20] tw-leading-[100%] tw-font-medium tw-mr-[7px] tw-mb-[4px]"
          >{{
            getComponentUiText(
              "app-component-wizards-setup-wizard-more-detail-title-1",
            )
          }}</span
        >
        <span
          class="tw-text-[12px] tw-font-poppins tw-text-[#878787] tw-leading-normal tw-font-normal tw-mr-[7px]"
          >{{
            getComponentUiText(
              "app-component-wizards-setup-wizard-more-detail-sub-title-1",
            )
          }}</span
        >
      </slot>
    </div>
    <div class="tw-flex tw-flex-end tw-items-center tw-bg-[#FFFFFF]">
      <ToggleSwitch
        :is-checked="isMoreDetails"
        color="#2573E9"
        @update:is-checked="changeMoreDetail"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import ToggleSwitch from "../common/toggleSwitch.vue";
import { getComponentUiText } from "@/utils/utilities";
import { ref, watchEffect } from "vue";

const emit = defineEmits(["update:modelValue"]);

const props = defineProps({
  classesMoreDetail: {
    type: String,
    default: "",
  },
  isShowQuestions: {
    type: Boolean,
    default: true,
  },
  isShowButtonBelow: {
    type: Boolean,
    default: true,
  },
  isDetails: {
    type: String,
    default: "",
  },
  isDetailsValidate: {
    type: String,
    default: "",
  },
});

let isMoreDetails = ref(false);

const changeMoreDetail = (value: any) => {
  isMoreDetails.value = value;
  emit("update:modelValue", value);
};
watchEffect(() => {
  if (props.isDetails) {
    isMoreDetails.value = true;
    emit("update:modelValue", true);
  }
});
watchEffect(() => {
  if (props.isDetailsValidate) {
    isMoreDetails.value = true;
    emit("update:modelValue", true);
  }
});
</script>
<style scoped lang="scss">
.border-bottom {
  border-bottom: 1px solid #e5e5e5;
}

@media screen and (max-width: 590px) {
  .more__detail {
    height: 120px !important;
  }
}
</style>
